import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import PieSet from "./AnalisiListing.PieSet";
import KPISet from "./AnalisiListing.KPISet";

const AnalisiListing = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Listings')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <KPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <Box className="report-itemgroup">
                    <PieSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

        </Box>
    )
}

export default AnalisiListing;